export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/ob-step-14.png?a4a197bd095f9656bb5d3a3e34e9d2fb";